import { render, staticRenderFns } from "./veStuPunishType.vue?vue&type=template&id=49d104e6&scoped=true"
import script from "./veStuPunishType.vue?vue&type=script&lang=js"
export * from "./veStuPunishType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d104e6",
  null
  
)

export default component.exports